import { request } from './request'

// 修改用户自己的信息
function editUserMsg(data) {
    return request({
        url: '/sys/user/editUserMsg',
        method: 'POST',
        data: data
    })
}
// 修改用户自己的密码
function editPassword(data) {
    return request({
        url: '/sys/user/editPassword',
        method: 'POST',
        data: data
    })
}

export default {
    editUserMsg,
    editPassword
}
